import React from 'react';

import BookEntries from '../BookEntries';

const TransactionsBook: React.FC = () => {
  return (
    <BookEntries
      isTransactional={true}
      allowEditing={false}
      title="Libro de Transacciones"
    />
  );
};

export default TransactionsBook;
